export default __webpack_public_path__ + "static/media/edit.e66e07b4.svg";